import type { BulkSelection } from "@/lib/api/model/bulkSelection";
import type { PipelineFilterSchema } from "@/lib/api/model/pipelineFilterSchema";
import { usePipelineViewStore } from "./view";

export type PipelineActionBody = {
  job_candidate_ids?: string[];
  bulk?: BulkSelection;
  stage_id?: string;
  search?: string;
  filters?: PipelineFilterSchema;
};

// Build the bulk-action payload from the live selection store. `include` mode
// ships explicit IDs; `all` mode ships a compact descriptor + active filters
// the backend resolves — so "select all" never fetches every candidate.
//
// The filters must match the ones the table was rendered with (same store, same
// mirror of the URL), or "select all" would act on a wider set than the user
// saw. The backend applies them through the same clause builder as the list.
export function buildPipelineActionBody(): PipelineActionBody | null {
  const s = usePipelineViewStore.getState();
  if (s.bulkMode === "all") {
    const bulk = s.getBulkSelection();
    if (!bulk) return null;
    return {
      bulk,
      stage_id: s.selectedStageId ?? undefined,
      search: s.filterSearch || undefined,
      filters: s.filters ?? undefined,
    };
  }
  const ids = Array.from(s.selectedCandidateIds);
  if (ids.length === 0) return null;
  return { job_candidate_ids: ids };
}
